/**
 * fade animation
 * @see fadeIn
 * @see fadeOut
 */

/**
* Fade in
* @param {HTMLElement} node フェードイン要素
* @param {number} duration アニメーションの時間
* @returns
*/
export function fadeIn(node, duration = 300) {
  // display: noneでないときは何もしない
  if (getComputedStyle(node).display !== 'none') return;

  // style属性にdisplay: noneが設定されていたとき
  if (node.style.display === 'none') {
    node.style.display = '';
  } else {
    node.style.display = 'block';
  }
  node.style.opacity = 0;

  const start = performance.now();

  requestAnimationFrame(function tick(timestamp) {
    // イージング計算式（linear）
    const easing = (timestamp - start) / duration;

    // opacityが1を超えないようにする
    node.style.opacity = Math.min(easing, 1);

    if (easing < 1) {
      // イージング計算式の値が1より小さいときはフェードインアニメーションを継続する
      requestAnimationFrame(tick);
    } else {
      node.style.opacity = '';
    }
  });
}

/**
* Fade out
* @param {HTMLElement} node フェードアウト要素
* @param {number} duration アニメーションの時間
*/
export function fadeOut(node, duration = 300) {
  node.style.opacity = 1;

  const start = performance.now();

  requestAnimationFrame(function tick(timestamp) {
    // イージング計算式（linear）
    const easing = (timestamp - start) / duration;

    // opacityが0より小さくならないようにする
    node.style.opacity = Math.max(1 - easing, 0);

    if (easing < 1) {
      // イージング計算式の値が1より小さいときはフェードアウトアニメーションを継続する
      requestAnimationFrame(tick);
    } else {
      // イージング計算式の値が1以上になったらnodeのdisplayをnoneにする
      node.style.opacity = '';
      node.style.display = 'none';
    }
  });
}